module.exports = __webpack_public_path__ + "img/icon-payment-app.bcf979c8.png";